import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, NavItem, Button, NavLink as BSNavLink, Progress } from 'reactstrap';
import bn from '../../../lib/utils/bemnames';
import { navItems } from '../../../routes/menu';
import R from '../../../lib/constants/R';
import SidebarPage from './SidebarPages';
import SourceLink from '../SourceLink';
import PropTypes from '../../../lib/utils/propTypes';
import { MdMenuOpen, MdRefresh } from 'react-icons/md';
import { genericsActions, notificationActions } from '../../../store/actions';
import api from '../../../api/appApi/api';
import { useUser } from 'Context/UserContext';
import { connect } from 'react-redux';


const sidebarBackground = {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
};

const bem = bn.create('sidebar');

const Sidebar = ({ onSidebar, onAddNotification }) => {
    const [isOpenSide, setIsOpenSide] = useState(true);
    const [isUpdating, setIsUpdating] = useState(0);
    const [progress, setProgress] = useState(0);
    const [progressPercent, setProgressPercent] = useState(0);
    const pollIntervalRef = useRef(null);
    const resetTimeoutRef = useRef(null);

    const clearPollInterval = () => {
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    };

    const clearResetTimeout = () => {
        if (resetTimeoutRef.current) {
            clearTimeout(resetTimeoutRef.current);
            resetTimeoutRef.current = null;
        }
    };

    useEffect(() => () => {
        clearPollInterval();
        clearResetTimeout();
    }, []);

    const handleScriptError = message => {
        clearPollInterval();
        setIsUpdating(3);
        onAddNotification(message || 'Erro ao atualizar', 'error');
        clearResetTimeout();
        resetTimeoutRef.current = setTimeout(() => {
            setIsUpdating(0);
            setProgressPercent(0);
        }, 10000);
    };

    const pollProgress = () => {
        clearPollInterval();

        pollIntervalRef.current = setInterval(async () => {
            try {
                const progressResponse = await api.get('/get-progress');

                if (progressResponse.status === 200) {
                    const { details, status } = progressResponse.data || {};
                    const message = details || 'Sem detalhes de progresso';
                    setProgress(message);

                    if (status === 'erro' || String(message).startsWith('ERRO:')) {
                        handleScriptError(message);
                        return;
                    }

                    const match = String(message).match(/(\d+(?:\.\d+)?)%/);
                    const percent = match ? parseFloat(match[1]) : 0;
                    setProgressPercent(percent);

                    if (percent >= 100) {
                        clearPollInterval();
                        setIsUpdating(0);
                    }
                }
            } catch (error) {
                console.error('Erro ao obter progresso:', error);
                handleScriptError('Erro ao obter progresso da atualização');
            }
        }, 1000);
    };

    const handleSidebarControlButton = event => {
        event.preventDefault();
        event.stopPropagation();
        const sidebar = document.querySelector('.cr-sidebar');
        const header = document.querySelector('.cr-header');
        sidebar.classList.toggle('cr-sidebar--open');
        header.classList.toggle('open');

        setIsOpenSide(!sidebar.classList.contains('cr-sidebar--open'));
        onSidebar(!sidebar.classList.contains('cr-sidebar--open'));
    };

    const handleClick = name => () => {
        setIsOpenSide(prevState => ({
            ...prevState,
            [`isOpen${name}`]: !prevState[`isOpen${name}`],
        }));
    };

    const modulePermission = modulesList => {
        if (modulesList.length > 0) {
            return modulesList.map((item, index) => (
                <SidebarPage
                    key={item.nome + index}
                    isOpen={isOpenSide[`isOpen${item.nome}`]}
                    namePages={item.nome}
                    click={name => handleClick(name)}
                    pageContents={item.submodulos}
                    IconPage={item.icone}
                />
            ));
        }

        return null;
    };

    const updateTableData = async () => {
        if (isUpdating === 1) {
            return;
        }

        setIsUpdating(1);
        setProgress(0);
        setProgressPercent(0);

        try {
            const response = await api.get('/executar-python');

            if (response.status === 202 || response.status === 200) {
                pollProgress();
            } else {
                handleScriptError('Erro ao atualizar');
            }
        } catch (error) {
            console.error('Erro ao executar o script:', error);
            handleScriptError(
                error?.response?.data?.message || 'Erro ao executar o script',
            );
        }
    };

    const { usuario } = useUser();

    let updateButtonLabel = 'Atualizar';
    if (isUpdating === 1) {
        updateButtonLabel = `${progress || 'Atualizando...'}`;
    } else if (isUpdating === 3) {
        updateButtonLabel = 'Erro ao atualizar';
    }

    return (
        <aside className={bem.b()} data-image={R.images.sidebar}>
            <div className={bem.e('background')} style={sidebarBackground} />

            <div className={bem.e('content')}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px 5px', position: 'relative' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <SourceLink>
                            <img src={R.images.logo_oficial} height="70" alt="" />
                        </SourceLink>
                    </div>
                    <div style={{ position: 'absolute', right: '5px' }}>
                        <Button
                            outline
                            onClick={handleSidebarControlButton}
                            className={bem.e('menu')}
                        >
                            <MdMenuOpen size={20} />
                        </Button>
                    </div>
                </div>

                <div>
                    <Nav vertical>
                        {navItems.map(({ to, name, exact, Icon }, index) => (
                            <NavItem key={name} className='custom-nav-item'>
                                <BSNavLink
                                    id={`navItem-${name}-${index}`}
                                    tag={NavLink}
                                    to={to}
                                    activeClassName="active"
                                    exact={exact}
                                >
                                    <Icon className={bem.e('nav-item-icon')} />
                                    <span className="nav-name">{name}</span>
                                </BSNavLink>
                            </NavItem>
                        ))}
                        {usuario?.modulo ? modulePermission(usuario.modulo) : null}

                        <NavItem key='Atualização' className='custom-nav-item'>
                            <Button
                                onClick={updateTableData}
                                className='updateButton'
                                disabled={isUpdating === 1}
                            >
                                <MdRefresh style={{ marginRight: '.5rem', color: '#CC9131', fontSize: '1.9rem' }} size={20} />
                                <span className="nav-name">
                                    {updateButtonLabel}
                                </span>
                            </Button>
                            {isUpdating === 1 && (
                                <Progress
                                    animated
                                    striped
                                    color="info"
                                    value={progressPercent}
                                    className="update-progress-bar"
                                >
                                    {`${progressPercent.toFixed(0)}%`}
                                </Progress>
                            )}
                        </NavItem>
                    </Nav>
                </div>
            </div>
        </aside>
    );
};

const mapStateToProps = state => ({
    modules: state.enterprise.modulesCompany,
    permissionsMenu: state.enterprise.permissionsMenu,
});

const mapDispatchToProps = dispatch => ({
    onSidebar: data => dispatch(genericsActions.sideBar(data)),
    onAddNotification: (message, level) =>
        dispatch(notificationActions.addNotification(message, level)),
});

Sidebar.propTypes = {
    permissionsMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
    modules: PropTypes.arrayOf(PropTypes.object).isRequired,
    onSidebar: PropTypes.func.isRequired,
    onAddNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
